import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators} from "@angular/forms";
import {AdminService} from "../../services/admin.service";
import {API_URL, MPAGO_APPID} from "../../../app.config";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import { HttpResponse } from "@angular/common/http";
import { PaymentsService } from '../../../payments/payments.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-admin-payment',
    templateUrl: './admin-payment.component.html',
    styleUrls: ['./admin-payment.component.scss', '../admin-main.common.scss'],
    standalone: false
})
export class AdminPaymentComponent implements OnInit {
  companyForm = this.fb.group({
    name: [{value: '', disabled: true}],
    preferences: this.fb.group({
      logo: '',
      address: '',
      phone: '',
      email_banner: '',
      work_days: new UntypedFormArray([
        new UntypedFormControl(true),
        new UntypedFormControl(true),
        new UntypedFormControl(true),
        new UntypedFormControl(true),
        new UntypedFormControl(true),
        new UntypedFormControl(true),
        new UntypedFormControl(true),
      ]),
      work_start_time: '08:00',
      work_end_time: '19:00',
      report_send_frecuency: 'weekly',
      report_role_ids: []
    }),
    email: [{value: '', disabled: true}],
    domain: [{value: '', disabled: true},
      Validators.pattern(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/)]
  });
  loading = false;
  payments = {}
  paymentTypes: any[] = [{
    name: 'Mercado Pago',
    key: 'mercado_pago',
    icon: 'fab fa-cc-visa',
    description: 'Mercado Pago es una plataforma de pagos en línea que permite realizar transacciones de forma segura y confiable.'
  }]
  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private paymentService: PaymentsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.route.queryParams.pipe(first()).subscribe(value => {
      if(value.code){
        firstValueFrom(this.paymentService.setupPayment('mercado_pago',{code: value.code})).then((response: HttpResponse<any>) => {
          if(response.status === 200){
            this.checkPaymentConfig('mercado_pago');
          }
        });
      }else{
        this.checkPaymentConfig('mercado_pago');
      }
    })
  }
  checkPaymentConfig(type){
    this.loading = true;
    this.paymentService.checkPayment(type).subscribe((response: any) => {
      if(response.status === 200 && response.body.ok){
        this.cdr.markForCheck();
        this.payments[type] = true;
        this.loading = false;
      }
    });
  }
  linkAccount(type){
    this.paymentService.oAuthUrl(type).subscribe((response: any) => {
      if(response.status === 200 && response.body.url)
        window.open(response.body.url, '_blank');
    });
  }
}
